import { useTranslation } from 'react-i18next';

import { ContactGroupType } from 'contacts/enums';
import { IContactGroup } from 'contacts/types';
import { SlidingPanel, Tabs } from 'core/components';

import { ContactGroupContactList } from './Contacts';
import { ContactGroupLocationList } from './Locations';
import { ContactGroupPricing } from './Pricing';
import { ContactGroupSettings } from './Settings';

export enum ContactGroupDetailsTab {
  CONTACTS = 'contacts',
  LOCATIONS = 'locations',
  PRICING = 'pricing',
  SETTINGS = 'settings',
}

interface IProps {
  isOpen: boolean;
  onClose: () => void;
  contactGroup: IContactGroup | null;
  contactGroupType: ContactGroupType;
  defaultTab?: ContactGroupDetailsTab;
  onEditContactGroupSuccess?: (contactGroup: IContactGroup) => void;
}

export const ContactGroupDetails = ({
  isOpen,
  onClose,
  contactGroup,
  contactGroupType,
  defaultTab = ContactGroupDetailsTab.CONTACTS,
  onEditContactGroupSuccess,
}: IProps) => {
  const { t } = useTranslation();

  const tabs = [
    {
      value: ContactGroupDetailsTab.CONTACTS,
      label: t('labelContacts'),
      content: <ContactGroupContactList groupType={contactGroupType} contactGroup={contactGroup} />,
    },
    {
      value: ContactGroupDetailsTab.LOCATIONS,
      label: t('labelLocations'),
      content: (
        <ContactGroupLocationList contactGroup={contactGroup} contactGroupType={contactGroupType} />
      ),
    },
    {
      value: ContactGroupDetailsTab.PRICING,
      label: t('labelPricing'),
      content: (
        <ContactGroupPricing
          contactGroup={contactGroup}
          onSubmitSuccess={onEditContactGroupSuccess}
        />
      ),
    },
    {
      value: ContactGroupDetailsTab.SETTINGS,
      label: t('labelSettings'),
      content: (
        <ContactGroupSettings
          contactGroup={contactGroup}
          onSubmitSuccess={onEditContactGroupSuccess}
        />
      ),
    },
  ];

  return (
    <SlidingPanel
      isOpen={isOpen}
      onClosePanel={onClose}
      title={t('titleContactGroupDetailsWithName', { name: contactGroup?.name })}
      autoWidth
      interactive
    >
      <Tabs tabs={tabs} ariaLabel={'contactGroupDetails'} defaultTab={defaultTab} />
    </SlidingPanel>
  );
};
